<template>
<div>
  <card v-if="spinning">
    <div class="row">
      <div class="col-md-12 text-center">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </div>
  </card>
  <card>
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css">
    <h4 class="custom-txt">User Scopes Management
    <el-tooltip content="Add New Scope">
      <el-button type="text" @click="openModal('scope')">
        <i class="fa-solid fa-circle-plus icon-green"></i>
      </el-button>
    </el-tooltip>
    </h4>
    <!-- Search Box -->
    <div class="row mb-4">
      <div class="col-sm-6">
    <el-input
      v-model="search"
      placeholder="Search scopes by name or description..."
      clearable>
      <span slot="prepend">Search</span>
    </el-input>
      </div>
      <el-button style="margin-left: -10px;" @click="search = ''">Clear</el-button>
    </div>
    <el-button type="text" @click="openModal('help')">
      <i class="fa-solid fa-circle-info"></i>
    </el-button>
    <el-table :data="paginatedScopes" border style="width: 100%; margin-top: -40px; z-index: 0">
      <el-table-column label="Assign to Auth Group" :header-align="headerAlignCenter">
          <div class="center-content">
          <el-tooltip content="Assign Scope to Auth Group">
          <el-button type="text" @click="assignAuthGroup">
            <i class="fa-solid fa-arrow-right"></i>
          </el-button>
          </el-tooltip>
          </div>
      </el-table-column>
      <el-table-column prop="name" label="Scope Name">
        <template slot-scope="scope">
          <fg-input type="text" v-model="scope.row.name" @input="debouncedUpdateName(scope.row.id, scope.row.name)"></fg-input>
          <!--<el-input v-model="scope.row.name" />-->
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description">
        <template slot-scope="scope">
          <fg-input type="text" v-model="scope.row.description" @input="debouncedUpdateDescription(scope.row.id, scope.row.description)"></fg-input>
          <!--<el-input v-model="scope.row.description" />-->
        </template>
      </el-table-column>
      <el-table-column class="text-center" label="Actions" :header-align="headerAlignCenter">
        <template slot-scope="scope">
          <div class="center-content">
          <!--<el-tooltip content="Update Scope">
            <el-button type="text" @click="updateScope(scope.row)">
              <i class="fa-regular fa-floppy-disk"></i>
            </el-button>
          </el-tooltip>-->
          <el-tooltip content="Delete Scope">
            <el-button type="text" @click="deleteScope(scope.row)">
              <el-icon name="delete" class="icon-large icon-red"></el-icon>
            </el-button>
          </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalItems">
    </el-pagination>
  </card>
  <el-dialog
    center
    title="Confirm Deletion of Scope"
    :visible.sync="modals.basic">
    <span>Are you sure you want to delete the scope: {{ delete_scope_name }}?</span>
    <span slot="footer" class="dialog-footer">
              <button class="btn btn-danger" @click="closeModal('basic')">Cancel</button>&nbsp;
              <button class="btn btn-success" @click="deleteScope()">Confirm</button>
            </span>
  </el-dialog>
  <el-dialog
    center
    title="Success"
    :visible.sync="modals.success">
    <div class="text-center">
      <span>Success: {{ success_txt }}</span>
      <br>
      <span slot="footer" class="dialog-footer">
<l-button class="mt-4" round type="btn btn-success" @click="closeModal('success')">OK</l-button>&nbsp;
</span>
    </div>
  </el-dialog>
  <el-dialog
    center
    title="Error"
    :visible.sync="modals.error">
    <div class="text-center">
      <span>Error: {{ error_txt }}</span>
      <br>
      <span slot="footer" class="dialog-footer">
<l-button round class="mt-4" type="btn btn-danger" @click="closeModal('error')">OK</l-button>&nbsp;
</span>
    </div>
  </el-dialog>
  <!-- Assign Dialog -->
  <el-dialog
    :visible.sync="modals.assign"
    width="50%">
    <div class="row mb-4" style="margin-top: -40px;">
      <div class="col-sm-12 text-center custom-txt">Assign Scopes to Auth Groups:</div>
    </div>
    <div style="display: flex;">
      <!-- Auth Groups List -->
      <div style="flex: 1;" class="text-center">
        <div class="assign-txt mb-1">Select an Auth Group:</div>
        <el-select v-model="selected_authgroup_id" placeholder="Select an Auth Group">
          <el-option
            v-for="group in auth_groups"
            :key="group.id"
            :label="group.name"
            :value="group.id">
          </el-option>
        </el-select>
      </div>

      <!-- Scopes List for Assignment -->
      <div style="flex: 2; margin-left: 20px;">
        <div class="assign-txt text-center mb-2">Choose a Scope to Assign:</div>
        <div class="text-center">
          <el-checkbox-group v-model="selected_scope_ids">
            <el-checkbox
              v-for="scope in scopes"
              :key="scope.id"
              :label="scope.id">
              {{ scope.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>

    <div class="col-sm-12 text-center mt-4">
      <button class="btn-blue btn-round mr-1" @click="saveScopes">Assign</button>
      <button class="btn-red btn-round" @click="closeModal('assign')">Cancel</button>
    </div>
  </el-dialog>
  <el-dialog width="30%" :visible.sync="modals.scope">
    <div class="row">
      <div class="col-sm-12">
        <div class="text-center">
          <h3 style="margin-top: -10px;">Add a New Scope</h3>
        </div>
      </div>
    </div>
    <el-form ref="addScopeForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="text-center mt-3">
            <div>
              <label>Scope Name:</label>
            </div>
              <el-input style="width: 300px;" class="sml-search" v-model="newScope.name"></el-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="text-center mt-3">
            <div>
              <label>Description:</label>
            </div>
              <el-input style="width: 300px;" class="sml-search" v-model="newScope.description"></el-input>
          </div>
        </div>
      </div>
    </el-form>
    <div class="text-center mt-4">
        <button :disabled="!newScope.name || !newScope.description" type="button" class="btn-blue btn-round mr-1" @click="addScope">Save</button>
        <button class="btn-red btn-round" @click="closeModal('scope')">Cancel</button>
    </div>
  </el-dialog>
  <el-dialog
    :visible.sync="modals.help">
    <div class="row" style="margin-top: -30px; font-size: 20px;">
      <div class="col-sm-12 text-center custom-txt">Scope Management</div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-center help-txt">
        Here, view and manage all permissions within your system.
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-center help-txt">
        <span style="font-weight: bold">Search Table:</span>
        You can search the table by scope name, or description. Find and click the search bar just above the table,
        and enter the value you would like to find within the table. The table will filter accordingly. In order to
        clear your search, click the button labeled 'Clear' next to the search bar, and the table will return to all
        original values.
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-center help-txt">
        <span style="font-weight: bold">Adding Scopes <i class="fa-solid fa-circle-plus" style="font-size: 17px;"></i> </span>
        To add a scope, click the green plus button at the top of the page. Then enter your scope name and description
        into the input fields. These fields are required, if you do not fill all of them out accordingly your scope
        will not be created. When you are finished, click the blue button labeled 'Save' in order to create your scope.
        If you do not want to create the scope, click the red button labeled 'Cancel' to stop the operation.
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-center help-txt">
        <span style="font-weight: bold">Assigning Scopes to Auth Groups <i class="fa-solid fa-arrow-right" style="font-size: 18px;"></i> </span>
        To assign a scope to an authentication group, click the green arrow button within the column labeled
        'Assign to Auth Group'. Then select the auth group you would like, and the scope you want to assign
        to the auth group. You can assign multiple scopes to auth groups at once. When you are finished, click
        the blue button labeled 'Assign' in order to assign your scope to your auth group. If you don't want to
        assign a scope, click the red button labeled 'Cancel' in order to stop the operation.
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-center help-txt">
        <span style="font-weight: bold">Updating Scopes:</span>
        To update a scope, simply click either the name or description and begin typing. Your system will update and save
        these changes automatically.
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-center help-txt">
        <span style="font-weight: bold">Deleting Scopes <el-icon name="delete" class="icon-red"></el-icon> </span>
        To delete a scope, click the red trash can button within the 'Actions' column. Before deleting a scope, ensure
        you are clicking the trash can that is in the same row as the scope you would like to delete. Once you delete
        a scope, the only way to retrieve it is by creating it again.
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-center mt-2">
        <button type="button" class="btn-blue btn-round" @click="closeModal('help')">Close</button>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { debounce } from 'lodash';
import { BSpinner } from 'bootstrap-vue';
import {Option, Select, Dialog, Button, Table, TableColumn, Form, FormItem, Checkbox, CheckboxGroup, Tooltip, Icon, Message, Pagination } from 'element-ui';
import { ScopesAPIService } from 'src/servicehandlers/ScopesAPIService';
import AuthGroupAPIService from "../../../../servicehandlers/AuthGroupAPIService";
const scopesAPIService = new ScopesAPIService();
const authGroupAPIService = new AuthGroupAPIService();

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip,
    [Icon.name]: Icon,
    [Message.name]: Message,
    [Pagination.name]: Pagination,
    BSpinner,
  },
  name: "AuthGroupsScopesAdmin",
  data() {
    return {
      newScope: {
        name: '',
        description: '',
      },
      name: '',
      description: '',
      search: '',
      searchTerm: null,
      spinning: false,
      scope_name: null,
      auth_groups: [],
      scope_description: null,
      delete_scope_id: null,
      delete_scope_name: null,
      selected_authgroup_id: null,
      selected_scope_id: null,
      last_selected_item: null,
      selected_scope_ids: [],
      headerAlignCenter: 'center',
      currentPage: 1,
      perPage: 50,
      pageSize: 20,
      pageSizes: [20, 50, 100, 200, 500, 1000],
      totalItems: 0,
      modals: {
        error: false,
        success: false,
        basic: false,
        scope: false,
        assign: false,
        help: false,
      },
      scopes: [],
      success_txt: '',
      error_txt: null,
    };
  },
  computed: {
    paginatedScopes() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = this.currentPage * this.pageSize;
      return this.filteredScopes.slice(start, end);
    },
    filteredScopes() {
      if (!this.search) {
        return this.scopes;
      }
      const searchLowerCase = this.search.toLowerCase();
      return this.scopes.filter(
        s => s.name.toLowerCase().includes(searchLowerCase) ||
          s.description.toLowerCase().includes(searchLowerCase)
      );
    }
  },
  watch: {
      filteredScopes: {
        handler(newVal) {
          this.totalItems = newVal.length;
        },
        immediate: true
      },
    selected_authgroup_id(newValue, oldValue) {
      if (newValue !== oldValue) {
        const selectedRow = this.auth_groups.find(group => group.id === newValue);
        if (selectedRow) {
          this.selectAuthgroup(selectedRow);
        }
      }
    }
  },
  created() {
    this.getAllScopes();
    this.getAllAuthgroups();
  },
  methods: {
    created() {
      // By default, the filtered scopes are all the scopes
      this.filteredScopes = this.scopes;
    },
    saveScopes() {
      this.spinning = true;
      if (!this.selected_authgroup_id) {
        this.error_txt = 'No authgroup was selected!';
        this.handleError();
        return;
      }
      if (this.selected_scope_ids.length <= 0) {
        this.error_txt = 'No scopes were selected!';
        this.handleError();
        return;
      }

      return scopesAPIService.addScopesToAuthgroup(this.selected_authgroup_id, this.selected_scope_ids, this.$router)
      .then(() => {
        this.closeModal('assign');
        this.clear();
        this.getAllScopes();
        this.getAllAuthgroups();
        this.success_txt = 'Successfully added scopes to authgroup!';
        this.handleSuccess();
      })
      .catch((error) => {
        this.error_txt = 'An error occurred while adding scopes to groups: ' + error;
        this.handleError();
      });
    },
    clear() {
      this.selected_authgroup_id = null;
      this.selected_scope_ids = [];
    },
    updateScope(row) {
      this.spinning = true;
      return scopesAPIService.updateScope(row.id, row, this.$router)
      .then(() => {
        this.handleSuccess('Successfully updated scope');
      })
      .catch((error) => {
        this.handleSuccess('failed to update scope!: ' + error);
      });
    },
    async assignAuthGroup() {
      this.openModal('assign');
      this.spinning = false;
    },
    async selectAuthgroup(row = null) {
      if (row) {
        this.selected_scope_id = row.id;
      }

      if (!this.selected_scope_id) {
        return;
      }

      this.spinning = true;

      try {
        if (row) {
          const selectedAuthGroup = await authGroupAPIService.getAuthGroupsWithScope(this.selected_scope_id, this.$router);

          this.selected_scope_ids = selectedAuthGroup.scopes.map(auth_group => {
            auth_group.text = auth_group.name;
            auth_group.value = auth_group.id;
            return auth_group.id;
          });
        }

        this.openModal('assign');
        this.spinning = false;
      } catch (error) {
        this.error_txt = 'Error getting scopes for auth group: ' + error;
        this.handleError();
      }
    },

    getAllAuthgroups() {
      this.spinning = true;
      return authGroupAPIService.getAuthGroups(this.$router)
      .then((agps) => {
        this.auth_groups = agps;
        for (const group of this.auth_groups) {
          group.text = group.name;
          group.value = group.id;
        }
        this.spinning = false;
      })
      .catch((error) => {
        this.error_txt = error;
        this.handleError();
      });
    },
    onSelect (items, lastSelectItem) {
      this.selected_scope_ids = items
      this.lastSelectItem = lastSelectItem
    },
    confirmDelete(scope_id, scope_name,) {
      this.delete_scope_id = scope_id;
      this.delete_scope_name = scope_name;
      this.openModal('basic');
    },
    deleteScope(row) {
      this.closeModal('basic');
      this.spinning = true;
      if (!row.id) {
        this.error_txt = 'No scope was selected';
        this.handleError();
        return;
      }

      return scopesAPIService.deleteScope(row.id, this.$router)
      .then(() => {
        this.getAllScopes();
        this.getAllAuthgroups();
        this.success_txt = 'Successfully deleted scope!';
        this.handleSuccess();
        this.delete_scope_id = null;
        this.delete_scope_name = null;
      })
      .catch((error) => {
        this.error_txt = 'Scope deletion failed: ' + error;
        this.handleError();
      });
    },
    addScope() {
      this.spinning = true;
      if (!this.newScope.name) {
        this.error_txt = 'No scope name set';
        this.handleError();
        return;
      }
      if (!this.newScope.description) {
        this.error_txt = 'No scope description set';
        this.handleError();
        return;
      }
      this.closeModal('scope');

      return scopesAPIService.createScope(this.newScope, this.$router)
      .then(() => {
        this.getAllScopes();
        this.getAllAuthgroups();
        this.success_txt = 'Successfully created scope!';
        this.handleSuccess();
        this.newScope.name = '';
        this.newScope.description = '';
      })
      .catch((error) => {
        this.error_txt = 'Scope creation failed: ' + JSON.stringify(error);
        this.handleError();
      });
    },

    getAllScopes() {
      this.spinning = true;
      return scopesAPIService.getScopes(this.$router)
      .then((response) => {
        this.spinning = false;
        this.scopes = response;
        for (const scope of this.scopes) {
          scope.text = scope.name;
          scope.value = scope.id;
        }
      })
      .catch((error) => {
        this.error_txt = 'Error getting scopes!: ' + error;
        this.handleError();
      });
    },
    debouncedUpdateName: debounce(function(id, name) {
      this.updateName(id, name);
    }, 500),
    updateName(id, name) {
      const scope_name = {
        id,
        name,
      };
      return scopesAPIService.updateScope(scope_name.id, scope_name, this.$router)
        .then(() => {
          this.success_txt = 'Successfully updated scope name';
          Message.success('Successfully updated scope name');
          // this.getAccounts();
        })
        .catch((error) => {
          this.error_txt = 'Failed to update scope name: ' + error;
          this.handleError();
        });
    },
    debouncedUpdateDescription: debounce(function(id, description) {
      this.updateDescription(id, description);
    }, 500),
    updateDescription(id, description) {
      const scope_description = {
        id,
        description,
      };
      return scopesAPIService.updateScope(scope_description.id, scope_description, this.$router)
        .then(() => {
          this.success_txt = 'Successfully updated scope description';
          Message.success('Successfully updated scope description');
          // this.getAccounts();
        })
        .catch((error) => {
          this.error_txt = 'Failed to update scope description: ' + error;
          this.handleError();
        });
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    openModal(name) {
      this.modals[name] = true;
    },
    handleSuccess(text) {
      this.success_txt = text;
      this.openModal('success');
      this.spinning = false;
      setTimeout(() => {
        this.modals['success'] = false;
      }, 1500); // Hide after 1.5 secs
    },
    handleError(error) {
      this.error_txt = error;
      this.openModal('error');
      this.spinning = false;
      setTimeout(() => {
        this.modals['error'] = false;
      }, 1500); // Hide after 1.5 secs
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1;
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
    },
  }
}
</script>

<style scoped>
.custom-txt {
  color: dimgrey;
  //font-size: 22px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.fa-circle-plus {
  color: mediumseagreen;
  font-size: 25px;
}
.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.fa-arrow-right {
  color: mediumseagreen;
  font-size: 18px;
}
.text-center {
  text-align: center;
}
.fa-floppy-disk {
  font-size: 19px;
  color: dodgerblue;
}
.sml-search {
  width: 250px;
}
.help-txt {
  word-break: keep-all;
  font-size: 15px;
}
.assign-txt {
  font-size: 17px;
  color: dimgray;
}
.disabled {
  cursor: not-allowed;
}
.btn-blue {
  color: white;
  background-color: dodgerblue;
  border: none;
}
.btn-red {
  color: white;
  background-color: red;
  border: none;
}
.icon-red {
  color: red;
  font-size: 20px;
}
.fa-circle-info {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 18px;
}
</style>
